/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const SCTransactionFormatter = (cellContent, row, rowIndex) => {
  const { scTransactionId } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {scTransactionId ? scTransactionId : "-"}
      </div>
      <> </>
    </>
  );
};
